/*
  This HOC is currentely used for radio input and will be used for checkbox as well
  to handle multiple options, number of columns, error and a field title.
*/
/* eslint-disable react/prop-types */
/* eslint-disable func-names */
import { OtherFieldOption } from '../RadioField/OtherFieldOption';

function withMultipleOptions(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return function ({
    fieldRequired,
    errorMessage,
    fieldID,
    options,
    showError,
    fieldText,
    value,
    handleOtherClick,
    otherChecked,
    handleOtherValueChange,
    otherFieldLabel,
    isOtherEnabled = false,
    fieldTitle,
    ...props
  }) {
    return (
      <>
        <div className="form__options-grid">
          {options &&
            options.map((option, index) => (
              <WrappedComponent
                key={option}
                {...props}
                fieldID={`${fieldID}_${index}`}
                showError={false}
                optionText={option}
                optionValue={option}
                checked={Array.isArray(value) && value.includes(option)}
              />
            ))}
        </div>
        {isOtherEnabled && (
          <OtherFieldOption
            otherFieldLabel={otherFieldLabel}
            otherChecked={otherChecked}
            handleOtherClick={handleOtherClick}
            placeholder="Enter text here"
            fieldId={fieldID}
            value={value}
            handleOtherOptionChange={handleOtherValueChange}
            displayOtherField={!options.includes(value) && otherChecked}
            fieldTitle={fieldTitle}
          />
        )}
        {showError && <div className="form__validation-error">{errorMessage}</div>}{' '}
      </>
    );
  };
}

export default withMultipleOptions;
